const fontFiles = {
  site: [
    "/fonts/ibm-plex-mono-9e1455e6e9c5866f.woff2",
    "/fonts/ibm-plex-mono-a76f53ca6612e7b3.woff2",
    "/fonts/ibm-plex-mono-ad4580d8cb4b5f62.woff2",
    "/fonts/ibm-plex-mono-c36f509c0a8f9f85.woff2",
    "/fonts/ibm-plex-sans-056e4e2459f57a00.woff2",
    "/fonts/ibm-plex-serif-9fbb32c4c07037bc.woff2",
  ],
  watch: [
    "/fonts/merriweather-078faa192aeb0a99.woff2",
    "/fonts/merriweather-a3289cbf5bb77bb5.woff2",
    "/fonts/merriweather-sans-69a9465bc51cf625.woff2",
    "/fonts/merriweather-sans-7f7b0fb7bb5927f0.woff2",
  ],
  sugarscape: [
    "/fonts/fraunces-109c501a32c8040e.woff2",
    "/fonts/fraunces-ae1d21f0a3120a56.woff2",
    "/fonts/ibm-plex-mono-a76f53ca6612e7b3.woff2",
    "/fonts/ibm-plex-mono-ad4580d8cb4b5f62.woff2",
    "/fonts/space-grotesk-a0d054c4af557de2.woff2",
  ],
} as const;

export function FontPreloads({ group }: { group: keyof typeof fontFiles }) {
  return fontFiles[group].map((href) => (
    <link
      key={href}
      rel="preload"
      as="font"
      type="font/woff2"
      href={href}
      crossOrigin="anonymous"
    />
  ));
}
